import { createContext, FC } from 'react';
import { RouteComponentProps, withRouter } from 'react-router';
import useBookingProcessStore, { BookingProcessStoreNS } from './useBookingProcessStore';

interface Props extends RouteComponentProps {
  children: JSX.Element;
}

export const BookingProcessStoreContext = createContext({} as BookingProcessStoreNS.Store);

const RootStore: FC<Props> = ({ children, history }) => {
  const store = useBookingProcessStore(history);

  return (
    <BookingProcessStoreContext.Provider value={store}>
      {children}
    </BookingProcessStoreContext.Provider>
  );
};

export default withRouter(RootStore);
